
<div class="chatPageContainer__main" :class="{'nowInput': nowInput}">
  <div v-if="marunage" class="chatPageContainer__giftBanner">
    <img class="chatPageContainer__giftBanner__pc"
         :src="marunage.amazon_gift_campaign ? imageUrl('/gift/amazon_campaign_banner_1000_86.jpg') : imageUrl('/gift/amazon_banner_1000_86.jpg')">
    <img class="chatPageContainer__giftBanner__sp"
         :src="marunage.amazon_gift_campaign ? imageUrl('/gift/amazon_campaign_banner_614_86.jpg') : imageUrl('/gift/amazon_banner_614_86.jpg')">
  </div>
  <div class="chatPageContainer__timeline">
    <div class="ui vertical loader" :class="{'active': loading}"></div>

    <div class="chatItemContainer">
      <div v-for="comment in comments" :key="comment.id">
        <div v-if="comment.is_own && comment.text" class="chatItem">
          <div class="chatItem__talk chatItem__talk--user">
            <div class="chatItem__talkMainContainer">
              <div class="chatItem__balloon chatItem__balloon--user">
                <div class="chatItem__text linebreak" v-html="$options.filters.urlize(comment.text)"></div>
              </div>
              <div class="chatItem__metaContainer  chatItem__metaContainer--user">
                <span class="chatItem__readStatus" v-show="comment.read">既読</span>
                <span class="chatItem__timestamp">{{ comment.created_at | formatDatetime }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="comment.text" class="chatItem">
          <div class="chatItem__talk chatItem__talk--concierge">
            <div class="chatItem__avatar">
              <img v-if="chat.marunage_shop" :src="chat.marunage_shop.shop.main_image.urls.small_square" class="chatItem__avatarImage">
              <img v-else :src="imageUrl('/marunagekun.png')" class="chatItem__avatarImage">
            </div>
            <div class="chatItem__talkMainContainer chatItem__talkMainContainer--concierge">
              <div class="chatItem__balloon chatItem__balloon--concierge">
                <div v-if="comment.text" class="chatItem__text linebreak" v-html="$options.filters.urlize(comment.text)"></div>
              </div>
              <div class="chatItem__metaContainer chatItem__metaContainer--concierge">
                <span class="chatItem__timestamp">{{ comment.created_at | formatDatetime }}</span>
                <a class="clickable chatItem__editCondition" v-if="comment.creator_role === 'afadmin'" @click="openMarunageEditDialog"><i class="fas fa-pencil-alt"></i> 希望日時・人数の変更</a>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="comment.json.type === 'SUGGESTION_EXPLANATION'" class="chatItem">
          <div class="chatItem__talk chatItem__talk--concierge">
            <div class="chatItem__avatar">
              <img :src="imageUrl('/marunagekun.png')" class="chatItem__avatarImage">
            </div>
            <div class="chatItem__talkMainContainer chatItem__talkMainContainer--concierge">
              <div class="chatItem__balloon chatItem__balloon--concierge">
                <div class="chatItem__text">
                  お店が見つかりました！<br />
                  ご紹介した店舗で<span class="chatItem__kininaruInlineBoxSuggestion">空き確認</span>を押すと、ご希望の条件で利用できるかお調べいたします！<br />
                  空室の有無は各店舗の担当者からチャットにてご連絡しますので、直接詳細をご確認ください。<br />
                  ご予約は店舗とのチャットでそのままご依頼いただけます。
                </div>
                <div class="chatItem__text--info">
                希望日時や人数を変更されたい場合は、以下の「予約日時・人数の変更」から変更ください。<br />
                別なエリア、または複数のエリアでお探しの際はチャットにてお申し付けください。
                </div>
              </div>
              <div class="chatItem__metaContainer chatItem__metaContainer--concierge">
                <span class="chatItem__timestamp">{{ comment.created_at | formatDatetime }}</span>
                <a class="clickable chatItem__editCondition" @click="openMarunageEditDialog"><i class="fas fa-pencil-alt"></i> 希望日時・人数の変更</a>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="comment.json.type === 'CANDIDATE_EXPLANATION'" class="chatItem">
          <div class="chatItem__talk chatItem__talk--concierge">
            <div class="chatItem__avatar">
              <img :src="imageUrl('/marunagekun.png')" class="chatItem__avatarImage">
            </div>
            <div class="chatItem__talkMainContainer chatItem__talkMainContainer--concierge">
              <div class="chatItem__balloon chatItem__balloon--concierge">
                <div class="chatItem__text">
                  店舗より立候補がありました！<br />
                  ご紹介した店舗で<span class="chatItem__kininaruInlineBoxCandidate">チャットする</span>を押すと、店舗様と直接連絡でき、条件などのご質問・ご相談ができます。<br />
                  ご予約は店舗とのチャットでそのままご依頼いただけます。<br />
                  <br />
                  また、他の店舗の紹介も必要でしたら、引き続きコンシェルジュのチャットにてご連絡ください。
                </div>
                <div class="chatItem__text--info">
                希望日時や人数を変更されたい場合は、以下の「予約日時・人数の変更」から変更ください。<br />
                別なエリア、または複数のエリアでお探しの際はチャットにてお申し付けください。
                </div>
              </div>
              <div class="chatItem__metaContainer chatItem__metaContainer--concierge">
                <span class="chatItem__timestamp">{{ comment.created_at | formatDatetime }}</span>
                <a class="clickable chatItem__editCondition" @click="openMarunageEditDialog"><i class="fas fa-pencil-alt"></i> 希望日時・人数の変更</a>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="comment.json.type === 'CANDIDATE_AND_SUGGESTION_EXPLANATION'" class="chatItem">
          <div class="chatItem__talk chatItem__talk--concierge">
            <div class="chatItem__avatar">
              <img :src="imageUrl('/marunagekun.png')" class="chatItem__avatarImage">
            </div>
            <div class="chatItem__talkMainContainer chatItem__talkMainContainer--concierge">
              <div class="chatItem__balloon chatItem__balloon--concierge">
                <div class="chatItem__text">
                  コンシェルジュがご希望に見合うおすすめの会場をピックアップいたしました！<br />
                  ☆立候補店舗空きあり☆と表示されているお店はお客様のご希望とマッチしておりすぐにご案内が可能なお店です！
                  <span class="chatItem__kininaruInlineBoxCandidate">チャットする</span>からやり取りが可能です。<br />
                  <br />
                  また、他のおすすめ店舗は<span class="chatItem__kininaruInlineBoxSuggestion">空き確認</span>を押すと、ご希望条件でご利用できるかお調べいたします！<br />
                  ご不明点などございましたらお気軽にコンシェルジュチャットにお申し付け下さいませ。
                </div>
              </div>
              <div class="chatItem__metaContainer chatItem__metaContainer--concierge">
                <span class="chatItem__timestamp">{{ comment.created_at | formatDatetime }}</span>
                <a class="clickable chatItem__editCondition" @click="openMarunageEditDialog"><i class="fas fa-pencil-alt"></i> 希望日時・人数の変更</a>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="comment.json.type === 'SUGGESTION'" v-for="suggest in comment.json.suggestions" :key="suggest.id" class="chatItem">
          <div class="chatItem__shopPanel">
            <div class="chatItem__shopPanelImage" :style="backgroundImage(suggest.shop.main_image.urls.medium)">
              <div v-if="suggest.candidate" class="chatItem__shopPanelInfoBadge ui center aligned spOnly">
                <div class="chatItem__shopPanelInfoBadgeText" style="margin: 8px;">立候補店舗<br />空きあり</div>
              </div>
            </div>
            <div class="chatItem__shopPanelInfo">
              <div class="chatItem__shopPanelInfoText">
                <div class="chatItem__shopPanelTitle">{{ suggest.shop.name }}</div>
                <p class="chatItem__shopPanelDescription">{{ suggest.shop.title }}</p>
                <p class="chatItem__shopPanelAccess">{{ suggest.shop.access }}</p>
                <ul class="chatItem__shopPanelMeta">
                  <li>
                    <span v-if="lowestPrice(suggest.shop)" class="chatItem__shopPanelMetaLabel">予算</span>
                    {{ lowestPrice(suggest.shop) | formatCurrency }}円〜
                  </li>
                  <li>
                    <span class="chatItem__shopPanelMetaLabel">最大人数</span>
                    <span v-if="suggest.shop.max_count" class="chatItem__shopPanelMetaCapacityMax">着席：{{ suggest.shop.max_count }}人</span>
                    <span v-if="suggest.shop.max_standing_count" class="chatItem__shopPanelMetaCapacitySeat">立席：{{ suggest.shop.max_standing_count }}人</span>
                  </li>
                </ul>
              </div>
              <div v-if="suggest.candidate" class="chatItem__shopPanelInfoBadge ui center aligned pcOnly">
                <div class="chatItem__shopPanelInfoBadgeText">立候補店舗<br />空きあり</div>
              </div>
            </div>
            <div v-if="suggest.shop.is_public && suggest.shop.rank !== 'D' && suggest.shop.twilio_tel" class="chatItem__shopPanelTwilioTelContainer pcOnly">
              <tel-link :value="suggest.shop.twilio_tel" class="shopStoreTel__num">
                <i class="phone icon"></i>{{ suggest.shop.twilio_tel }}
              </tel-link>
            </div>
            <div v-if="suggest.shop.is_public && suggest.shop.rank !== 'D'" class="chatItem__shopPanelActionContainer">
              <div class="chatItem__shopPanelActionContainer__itemList">
                <div class="chatItem__shopPanelActionContainer__item chatItem__shopPanelCandidateMessage">
                  <a v-if="suggest.candidate" @click="openCandidateDialog(suggest.candidate)"><i class="far fa-envelope"></i><span>お店からのメッセージを確認する</span></a>
                </div>
                <div v-if="suggest.shop.twilio_tel" class="chatItem__shopPanelActionContainer__item chatItem__shopPanelTwilioTelContainer spOnly">
                  <tel-link :value="suggest.shop.twilio_tel" class="shopStoreTel__num">
                    <i class="phone icon"></i>{{ suggest.shop.twilio_tel }}
                  </tel-link>
                </div>
              </div>
              <div class="chatItem__shopPanelActionContainer__itemList">
                <div class="chatItem__shopPanelActionContainer__item">
                  <a :href="suggest.shop.detail_url + '?chat_id=' + chat.id" target="_blank"><button class="ui button">詳しく見る</button></a>
                </div>
                <div class="chatItem__shopPanelActionContainer__item">
                  <button v-if="suggest.status === 'none'" class="ui button"
                          :class="{'loading disabled': suggest.waiting, 'green': suggest.candidate, 'orange': !suggest.candidate}"
                          @click="suggest.candidate ? openShopChat(suggest) : like(suggest)">{{ suggest.candidate ? 'チャットする' : '空き確認' }}
                  </button>
                  <div v-else class="ui button disabled"
                        :class="{'green': suggest.candidate || suggest.status === 'active',
                                  'orange': !(suggest.candidate || suggest.status === 'active')}">{{ suggest.status_label }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="comment.json.type === 'LIKE'" class="chatItem">
          <div class="chatItem__userActionResult">
            <i class="fas fa-utensils chatItem__userActionResultIcon"></i>「{{ comment.json.shop.name }}」に空き確認を押しました
          </div>
        </div>
        <div v-else-if="comment.json.type === 'LIKE_ACCEPTED'" class="chatItem">
          <div class="chatItem__talk chatItem__talk--concierge">
            <div class="chatItem__avatar">
              <img v-if="chat.marunage_shop" :src="chat.marunage_shop.shop.main_image.urls.small_square" class="chatItem__avatarImage">
              <img v-else :src="imageUrl('/marunagekun.png')" class="chatItem__avatarImage">
            </div>
            <div class="chatItem__talkMainContainer chatItem__talkMainContainer--concierge">
              <div class="chatItem__balloon chatItem__balloon--concierge">
                <div class="chatItem__text">
                「{{ comment.json.shop.name }}」の空席をお調べ致します。<br />
                  空室の有無は各店舗の担当者からチャットにてご連絡しますので、直接詳細をご確認ください。<br />
                  ご予約は店舗とのチャットでそのままご依頼いただけます。
                  <div v-if="comment.json.shop.twilio_tel">
                    <br />
                    お急ぎの方はお電話でお問い合わせください。<br />
                    ■{{ comment.json.shop.name }}<br />
                    <span class="chatItem__twilioTelContainer">
                      <tel-link :value="comment.json.shop.twilio_tel" class="shopStoreTel__num">
                        <i class="phone icon"></i>{{ comment.json.shop.twilio_tel }}
                      </tel-link>
                    </span>
                  </div>
                </div>
              </div>
              <div class="chatItem__metaContainer chatItem__metaContainer--concierge">
                <span class="chatItem__timestamp">{{ comment.created_at | formatDatetime }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="comment.json.type === 'MARUNAGE_UPDATED'" class="chatItem">
          <div class="chatItem__userActionResult">希望条件が更新されました</div>
        </div>

        <div v-else-if="comment.json.type === 'REPLY_RESERVATION_OK' || comment.json.type === 'REPLY_RESERVATION_OK_WITH_CONSULT'" class="chatItem">
          <div class="chatItem__talk chatItem__talk--concierge">
            <div class="chatItem__avatar">
              <img v-if="chat.marunage_shop" :src="chat.marunage_shop.shop.main_image.urls.small_square" class="chatItem__avatarImage">
              <img v-else :src="imageUrl('/marunagekun.png')" class="chatItem__avatarImage">
            </div>
            <div class="chatItem__talkMainContainer chatItem__talkMainContainer--concierge">
              <div class="chatItem__balloon chatItem__balloon--concierge">
                <div class="chatItem__text">
                  「{{ comment.json.shop.name }}」から<b>空室あり</b>の連絡がきています。<br>
                  詳細は<a :href="comment.json.chat_url">店舗とのチャット</a>にて直接ご確認ください。<br>
                  ご予約は店舗とのチャットでそのままご依頼いただけます。
                </div>
              </div>
              <div class="chatItem__metaContainer chatItem__metaContainer--concierge">
                <span class="chatItem__timestamp">{{ comment.created_at | formatDatetime }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="comment.json.type === 'REPLY_RESERVATION_NG'" class="chatItem">
          <div class="chatItem__talk chatItem__talk--concierge">
            <div class="chatItem__avatar">
              <img v-if="chat.marunage_shop" :src="chat.marunage_shop.shop.main_image.urls.small_square" class="chatItem__avatarImage">
              <img v-else :src="imageUrl('/marunagekun.png')" class="chatItem__avatarImage">
            </div>
            <div class="chatItem__talkMainContainer chatItem__talkMainContainer--concierge">
              <div class="chatItem__balloon chatItem__balloon--concierge">
                <div class="chatItem__text">
                  残念ながら「{{ comment.json.shop.name }}」は<b>空席がありません</b>でした。<br>
                  詳細は<a :href="comment.json.chat_url">店舗とのチャット</a>にて確認してください。
                </div>
              </div>
              <div class="chatItem__metaContainer chatItem__metaContainer--concierge">
                <span class="chatItem__timestamp">{{ comment.created_at | formatDatetime }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="comment.json.type === 'RESERVATION_OK'" class="chatItem">
          <div class="chatItem__shopActionResult">
          [空席あり]<br>
          お席のご用意が可能です。<br>
          ご予約は本チャットにてご依頼ください。
          </div>
        </div>
        <div v-else-if="comment.json.type === 'RESERVATION_OK_WITH_CONSULT'" class="chatItem">
          <div class="chatItem__shopActionResult">
            [空席あり]<br>
            お席のご用意が可能ですが、会場様とご相談が必要です。<br>
            条件をこちらのチャットでご確認ください。
          </div>
        </div>
        <div v-else-if="comment.json.type === 'RESERVATION_NG'" class="chatItem">
          <div class="chatItem__shopActionResult">
          [空席なし]<br>
          ご指定の条件ではお席をご用意できません。<br>
          本チャットにて別な条件で空席の有無をご確認いただけます。
          </div>
        </div>

        <div v-else-if="comment.json.type === 'COMMIT_RESERVATION'" class="chatItem">
          <div class="chatItem__shopActionResult">
          「{{ comment.json.shop.name }}」が予約を受付ました。<br>
          </div>
        </div>
        <div v-else-if="comment.json.type === 'EDIT_RESERVATION'" class="chatItem">
          <div class="chatItem__shopActionResult">
          「{{ comment.json.shop.name }}」の予約が変更されました。
          </div>
        </div>
        <div v-else-if="comment.json.type === 'CANCEL_RESERVATION'" class="chatItem">
          <div class="chatItem__shopActionResult">
          「{{ comment.json.shop.name }}」の予約がキャンセルされました。
          </div>
        </div>

      </div>


      <!--div class="chatItem">
        <div class="chatItem__talk chatItem__talk--concierge">
          <div class="chatItem__avatar">
            <img :src="imageUrl('/marunagekun.png')" class="chatItem__avatarImage">
          </div>
          <div class="chatItem__talkMainContainer chatItem__talkMainContainer--concierge">
            <div class="chatItem__balloon chatItem__balloon--concierge">
              <div class="chatItem__text">
                希望に合うお店でしたか？
              </div>
              <div class="chatItem__balloonButtonContainer">
                <button class="ui button large grey">はい</button>
                <button class="ui button large grey">いいえ</button>
              </div>
              <div class="chatItem__balloonButtonContainer">
                <div class="ui button large orange disabled">はい</div>
                <button class="ui button large disabled">いいえ</button>
              </div>
            </div>
            <div class="chatItem__metaContainer chatItem__metaContainer--concierge">
              <span class="chatItem__timestamp">10:32</span>
            </div>
          </div>
        </div>
      </div-->

    </div>
  </div>

  <div class="chatPageContainer__chatFormContainer">
    <button @click="openBanquetsDialog" class="chatPageContainer__proposalListButton ui button circular tiny yellow">
      候補のお店を見る
    </button>
    <form class="ui form chatPageContainer__chatForm" @submit.prevent="post()">
      <div class="field chatPageContainer__chatInputAreaContainer">
        <textarea v-model.trim="postForm.model.text" :rows="inputRows" class="chatPageContainer__chatInputArea" @focus="onFocusTextarea"></textarea>
      </div>
      <button type="submit" class="ui primary large button chatPageContainer__chatSendButton" :class="{'loading': postForm.waiting}"
      ><i class="fas fa-paper-plane chatPageContainer__chatSendButtonIcon"></i></button>
    </form>
  </div>

</div>
